import { render, staticRenderFns } from "./BasicCardTemplate.vue?vue&type=template&id=5d1b2a46&"
import script from "./BasicCardTemplate.vue?vue&type=script&lang=ts&"
export * from "./BasicCardTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./BasicCardTemplate.vue?vue&type=style&index=0&id=5d1b2a46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports